import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

/*
 * Trunc a number to 1k, 1M or 1B
 * Usage:
 *   value | truncNumber
 *   with value the value to transform and digits the number of digits to show after the decimal point
 * Example:
 *   {{ 2500 | truncNumber }}
 *   formats to: 2.5k
*/

@Pipe({
  name: 'truncNumber',
})
export class TruncNumberPipe implements PipeTransform {

  constructor(
  ) {}

  transform(value: number, suffix: string | undefined): any {
    if (value === null) { return null; }
    let transformedValue =  this.shortenNumber(value);
    return transformedValue + (suffix ? suffix : '');
  }

  shortenNumber(value): string {
    if (value === null) { return null; }
    if (value === 0) { return '0'; }
    const fractionSize = 1;
    let abs = Math.abs(value);
    const rounder = Math.pow(10, fractionSize);
    const isNegative = value < 0;
    let key = '';
    const powers = [
      { key: 'B', value: Math.pow(10, 9) },
      { key: 'M', value: Math.pow(10, 6) },
      { key: 'k', value: 1000 }
    ];
    for (let i = 0; i < powers.length; i++) {
      let reduced = abs / powers[i].value;
      reduced = Math.round(reduced * rounder) / rounder;
      if (reduced >= 1) {
        abs = reduced;
        key = powers[i].key;
        break;
      }
    }
    return (isNegative ? '-' : '') + abs + key;
  };
}
